import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-dark text-cream pt-24 pb-10">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16 border-b border-warm-dark">
          <div className="lg:col-span-5">
            <Link to="/" className="flex items-baseline gap-2">
              <span className="font-serif-display text-4xl leading-none">TL</span>
              <span className="text-[10px] tracking-luxury uppercase text-gold-soft font-medium">
                Event Group
              </span>
            </Link>
            <p className="mt-8 text-sm leading-relaxed text-cream/70 max-w-md font-light">
              {t('footer.desc')}
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-[11px] tracking-luxury uppercase text-gold mb-6">{t('footer.navigation')}</h4>
            <ul className="space-y-3 text-sm text-cream/80 font-light">
              <li><Link to="/structures" className="link-underline">{t('nav.structures')}</Link></li>
              <li><Link to="/portfolio" className="link-underline">{t('nav.portfolio')}</Link></li>
              <li><Link to="/about" className="link-underline">{t('nav.about')}</Link></li>
              <li><Link to="/contact" className="link-underline">{t('nav.contact')}</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-[11px] tracking-luxury uppercase text-gold mb-6">{t('footer.contact')}</h4>
            <ul className="space-y-4 text-sm text-cream/80 font-light">
              <li className="flex items-start gap-3">
                <Mail size={15} className="mt-0.5 text-gold-soft" />
                <a href="mailto:info@tleventgroup.com" className="link-underline">info@tleventgroup.com</a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={15} className="mt-0.5 text-gold-soft" />
                <a href="tel:+32472649659" className="link-underline">+32 472 64 96 59</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={15} className="mt-0.5 text-gold-soft" />
                <span>{t('footer.areaValue')}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 pt-8">
          <p className="text-[11px] tracking-medium text-cream/50">
            © {new Date().getFullYear()} TL Event Group. {t('footer.copy')}
          </p>
          <p className="text-[11px] tracking-medium text-cream/50">
            {t('footer.tag')}
          </p>
        </div>
      </div>
    </footer>
  );
}
